"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setAuthToken = exports.SET_AUTH_TOKEN = void 0;
var SET_AUTH_TOKEN;
(function (SET_AUTH_TOKEN) {
    SET_AUTH_TOKEN["ACTION"] = "SET_AUTH_TOKEN_ACTION";
})(SET_AUTH_TOKEN = exports.SET_AUTH_TOKEN || (exports.SET_AUTH_TOKEN = {}));
var setAuthToken = function (token) { return ({
    type: SET_AUTH_TOKEN.ACTION,
    token: token,
}); };
exports.setAuthToken = setAuthToken;
//# sourceMappingURL=setAuthToken.js.map